module.exports = __webpack_public_path__ + "media/images/emblems/Lauenen-coat_of_arms-d7571b6f77dd5fd31ac69d2f61caf48b.svg";